import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send, ClipboardList } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { formatDeShort } from "@/lib/date";

export default function AvgsFeedbackPanel({ clientId }) {
  const [d, setD] = useState(null);
  const [sending, setSending] = useState(false);
  const load = () => api.get(`/avgs-feedback/client/${clientId}`).then((r) => setD(r.data)).catch(() => setD({ feedback: null, questions: [] }));
  useEffect(() => { load(); }, [clientId]); // eslint-disable-line

  const send = async () => {
    setSending(true);
    try {
      const { data } = await api.post(`/avgs-feedback/client/${clientId}/send`);
      toast.success(`Feedbackbogen an ${data.email} gesendet`);
      load();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setSending(false); }
  };

  if (!d) return null;
  const f = d.feedback;
  const status = !f ? "Noch nicht versendet" : f.submitted ? `Ausgefüllt am ${formatDeShort(f.submitted_at)}` : `Versendet am ${formatDeShort(f.sent_at)} · offen`;
  return (
    <div className="border border-slate-200 bg-white mt-6" data-testid="avgs-feedback-panel">
      <div className="px-5 py-3 border-b border-slate-200 flex items-center justify-between gap-3 flex-wrap">
        <div>
          <div className="text-[10px] font-bold uppercase tracking-overline text-slate-500 flex items-center gap-1.5">
            <ClipboardList size={12} strokeWidth={1.5} /> Offboarding
          </div>
          <div className="font-heading text-xl font-light tracking-tighter text-slate-900">Feedbackbogen</div>
          <div className="text-xs text-slate-500 mt-0.5" data-testid="avgs-feedback-status">{status}</div>
        </div>
        {!f?.submitted && (
          <button onClick={send} disabled={sending} data-testid="avgs-feedback-send-btn"
            className="px-4 py-2 text-xs font-medium bg-slate-900 text-white hover:bg-black disabled:opacity-50 flex items-center gap-1.5">
            <Send size={12} strokeWidth={1.5} /> {sending ? "Sendet…" : f ? "Erneut senden" : "Feedbackbogen senden"}
          </button>
        )}
      </div>
      {f?.submitted && f.answers && (
        <div className="p-5 space-y-2" data-testid="avgs-feedback-answers">
          {d.questions.map((q, i) => (
            <div key={q.id} className="flex items-start justify-between gap-4 text-sm">
              <span className="text-slate-700">{i + 1}. {q.text}</span>
              <span className="font-mono text-slate-900 shrink-0">{f.answers[q.id]} / 5</span>
            </div>
          ))}
          {f.comment && <div className="pt-3 mt-2 border-t border-slate-100 text-sm text-slate-800 whitespace-pre-wrap">„{f.comment}"</div>}
        </div>
      )}
    </div>
  );
}
